import { useCallback } from "react";
import agent from "../../../../../../../../API/apiCalls";
import { GlobalResponseModel, IEscalationComments } from "../../../../../../../../Models/applicationModels";
import { toast } from "react-toastify";
import { OPPORTUNITY_UID_KEY, APPLICATION_ESCALATION_UID_KEY, COMMENT_TYPE_KEY, COMMENT_KEY, FILES_KEY, ESCALATION_STATUS_KEY, UPDATE_IN_EMAIL_THREAD_KEY } from "../../../../../../createEscalation.constants";
import { CommentItemSaveData } from "../../commentSection.models";
import { useEscalationInfo } from "../../../../../../../../Context/escalationContext";

export const useAddEscalationComment = () => {
    const { setFlagUpdateEscalation } = useEscalationInfo();
    const addEscalationComment = useCallback(async (commentPayload: CommentItemSaveData, setCommentItems: (items: IEscalationComments[]) => void) => {
        try {
            const payloadData = {
                [OPPORTUNITY_UID_KEY]: commentPayload.opportunityUid,
                [APPLICATION_ESCALATION_UID_KEY]: commentPayload.applicationEscalationUid,
                [COMMENT_TYPE_KEY]: commentPayload.commentType,
                [COMMENT_KEY]: commentPayload.comment,
                [ESCALATION_STATUS_KEY]: commentPayload.escalationStatus,
            }
            const formData = new FormData();
            Object.entries(payloadData).forEach(([key, value]) => formData.append(key, value));
            formData.append(UPDATE_IN_EMAIL_THREAD_KEY, commentPayload.updateInEmailThread.toString());
            commentPayload.files?.forEach((file) => formData.append(FILES_KEY, file));

            const response: GlobalResponseModel<IEscalationComments[]> = await agent.AddEscalationComment.postForm(formData);
            if (response.flagStatus) {
                setCommentItems(response.value);
                setFlagUpdateEscalation(true);
            } else {
                toast.error(response.error ?? "Error in adding escalation comment");
            }
        } catch (error) {
            console.error(error);
        }
    }, []);

    return { addEscalationComment };
}